<template>

<core-list-column :format="{}" class="column"></core-list-column>

</template>

<script>

export default {

	props: []

}

</script>

<style scoped>

.column {
	width: 48px;
	flex-shrink: 0;
}

</style>